/** Max size for Excel/CSV bulk uploads. Keep in sync with EXCEL_MAX_FILE_SIZE_MB in montessori_backend/utils/multerUpload.js. */
export const EXCEL_MAX_FILE_SIZE_MB = 5;
export const EXCEL_MAX_FILE_SIZE_BYTES = EXCEL_MAX_FILE_SIZE_MB * 1024 * 1024;

export const EXCEL_SIZE_HINT = `Max file size: ${EXCEL_MAX_FILE_SIZE_MB} MB (.xlsx, .xls)`;

/** Returns an error message when the file exceeds the Excel size limit, otherwise "". */
export function getExcelSizeError(file) {
  if (!file || file.size <= EXCEL_MAX_FILE_SIZE_BYTES) return "";
  const sizeMb = (file.size / (1024 * 1024)).toFixed(2);
  return `File is too large (${sizeMb} MB). Maximum allowed size is ${EXCEL_MAX_FILE_SIZE_MB} MB.`;
}
